<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :close-action="() => { $GlobalStore.closeLastModal() }" :title="'내가 작성한 글'" :back-title="'뒤로가기'"></MercenaryHeader>
        <div style="display: flex; justify-content: center; align-items: center; gap: 4px; position: sticky; top: 0; background-color: #fff; padding: 8px 0; z-index: 5;">
            <div @click="setTopBtn(BTN_TYPE.QUESTION)" :style="{ color: curType === BTN_TYPE.QUESTION ? '#fff' : '#808080', backgroundColor: curType === BTN_TYPE.QUESTION ? '#210f03' : '' }" class="top_btn">훈련 질문</div>
            <div @click="setTopBtn(BTN_TYPE.REQUEST)" :style="{ color: curType === BTN_TYPE.REQUEST ? '#fff' : '#808080', backgroundColor: curType === BTN_TYPE.REQUEST ? '#210f03' : '' }" class="top_btn">입단 요청</div>
        </div>
        <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle" style="flex: 1; overflow: hidden;">
            <div style="margin-top: 20px; padding: 0 12px; height: 100%;">
                <div style="font-weight: 500;font-size: 20px;line-height: 24px; margin-bottom: 20px;"><span style="font-weight: 700;">{{ totalCnt }}개</span>의 게시물</div>
                <div style="margin-bottom: 28px; border-bottom: 1px solid #f5f5f5; padding-bottom: 28px;" v-for="each, i in postList" :key="i">
                    <CommonPost :refresh="refresh" :isExpert="isExpert" :isFeed="curType === BTN_TYPE.QUESTION ? true : false" :soccerHows="each"></CommonPost>
                </div>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
const BTN_TYPE = {
    QUESTION: '훈련질문',
    REQUEST: '입단요청'
}

import MercenaryHeader from "@/components/common/MercenaryHeader"
import InfinityScroll from "@/components/common/InfinityScroll"
import { SOCCER_HOW_TYPE } from "@/Constants"
import CommonPost from '@/components/soccerhowmain/CommonPost'

export default {
    name: 'MyPostList',
    components: {
        MercenaryHeader, InfinityScroll, CommonPost
    },
    props: {

    },
    computed: {
        isExpert() {
            if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        },
        isExpertConfirmed() {
            if (this.$GlobalStore.isLogin() && this.$GlobalStore.loginInfo().is_coach === '1') {
                return true
            } else {
                return false
            }
        },
    },
    data() {
        return {
            curType: BTN_TYPE.QUESTION,
            BTN_TYPE: BTN_TYPE,
            page: 1,
            postList: [],
            isEnableNextPageHandle: true,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            totalCnt: 0
        }
    },
    created() {
        this.getPostList()
    },
    methods: {
        setTopBtn(type) {
            this.curType = type
            this.refresh()
        },
        async getPostList() {
            this.isEnableNextPageHandle = false
            const questionType = [SOCCER_HOW_TYPE.SC_COUNSEL, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_JOB]
            const requestType = [SOCCER_HOW_TYPE.SINGLE_TRAINING, SOCCER_HOW_TYPE.GROUP_TRAINING]
            const parameters = {}
            parameters.page = this.page
            parameters.types = this.curType === BTN_TYPE.QUESTION ? requestType : questionType

            const res = await this.$Axios.get('/api/soccerhow/mine', { params: parameters })
            const result = res.data.soccerhows

            if (this.page === 1) {
                this.totalCnt = res.data.soccerhows_total_cnt
            }
            if (result.length > 0) {
                this.isEnableNextPageHandle = true
                this.postList = [...this.postList, ...result]
            }
        },
        handleNextPage() {
            this.page++
            this.getPostList()
        },
        refresh() {
            this.postList = []
            this.page = 1
            this.totalCnt = 0
            this.getPostList()
        }
    }
}
</script>

<style scoped>
.top_btn {
    width: 84px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}
</style>